var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconTrash = function SvgIconTrash(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1C4566",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.217 24.1c.4 0 .7-.3.7-.7V17c0-.4-.3-.7-.7-.7-.4 0-.601.3-.601.7v6.4c0 .4.3.7.6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.93 12.7h-4.106V12c0-1.1-.901-2-1.902-2h-3.104c-1.102 0-1.903.9-1.903 2v.7H10.81c-.4 0-.701.3-.701.7 0 .4.3.6.7.6h1.302l.3 10.3c.1 1.8 1.403 3.1 3.105 3.1h5.607c1.702 0 3.104-1.4 3.104-3.1l.4-10.3h1.302c.401 0 .701-.3.701-.7 0-.4-.3-.6-.7-.6zm-5.408-.7v.7h-4.305V12c0-.3.3-.6.6-.6h3.105c.4 0 .6.2.6.6zm2.504 12.3c0 1-.801 1.8-1.803 1.8h-5.607c-1.001 0-1.802-.8-1.802-1.8l-.4-10.3h9.912l-.3 10.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.52 24.1c.4 0 .7-.3.7-.7V17c0-.4-.3-.7-.7-.7-.4 0-.701.3-.701.7v6.4c0 .4.3.7.7.7zM20.723 24.1c.4 0 .7-.3.7-.7V17c0-.4-.3-.7-.7-.7-.4 0-.601.3-.601.7v6.4c0 .4.2.7.6.7z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconTrash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-trash.caafd4e2.svg";
export { ForwardRef as ReactComponent };